module.exports = __webpack_public_path__ + "img/valance-scallop.6acc3e5b.svg";